import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { ILicenseResolver } from '@nimbus-library/features/feature-permission/models/i-license-resolver';
import { LicenseSKU } from '@nimbus-portal/features/feature-permission/services/contact-license-capability.model';
import { AcUserProfileState } from '@nimbus-portal/features/attendant-console/store/ac-user-profile/ac-user-profile.state';

@Injectable()
export class AcO365LicenseResolver implements ILicenseResolver<LicenseSKU> {
  public constructor(private readonly store: Store) {}

  public resolve$(licenseId: LicenseSKU[]): Observable<boolean> {
    return this.store.select(AcUserProfileState.hasLicense(licenseId));
  }
}
